/**
 * A design token's resolved value, read from the `--as-*` custom properties that
 * tokens.scss puts on :root. For what SCSS cannot reach, such as colours a canvas
 * chart paints. Undefined when the token is missing or there is no DOM, so the
 * caller falls back to the library's default rather than to a literal.
 */
export function cssToken(name, el) {
	try {
		const target = el ?? document.documentElement;
		const value = getComputedStyle(target).getPropertyValue(name).trim();
		return value || undefined;
	} catch (e) {
		return undefined;
	}
}
